import { render } from "./PrimerAcceso.vue?vue&type=template&id=01164074&scoped=true"
import script from "./PrimerAcceso.vue?vue&type=script&lang=js"
export * from "./PrimerAcceso.vue?vue&type=script&lang=js"

import "./PrimerAcceso.vue?vue&type=style&index=0&id=01164074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01164074"]])

export default __exports__